import {Injectable} from '@angular/core';
import {UserService} from '../service/user.service';
import {Keys, StorageService} from '../service/storage.service';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class PanInformationResolver implements Resolve<{ pan: string, name: string } | null> {
    private readonly userService: UserService;
    private readonly storageService: StorageService;

    constructor(storageService: StorageService, userService: UserService) {
        this.storageService = storageService;
        this.userService = userService;
    }

    public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{ pan: string; name: string } | null> {
        const name = this.storageService.getItem(Keys.NAME);
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const pan = this.storageService.getObjectFromSession<string>(Keys.PAN);
        if (profileId) {
            const user = await this.userService.getProfileDetails(profileId);
            return {pan: user.pan.pan_no, name: user.name};
        } else if (name && pan) {
            return {name, pan};
        }
        return null;
    }
}